import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';
import { WidgethelperService } from '../widgethelper.service';

@Injectable()
export class WaveperformanceService {

  private hub: SignalRConnection;

  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) { }

  chartOptions() {
    return {
      title: {        
        textStyle: {
          color: '#fff'
        }
      },
      grid: {        
        left: '6%',
        right: '4%',
        bottom: '6%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        formatter: this._widgetHelper.WavePerformanceTooltip
      },

      legend: {
        top: '4%',
        textStyle: {
          color: "#fff"
        }
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 100
        },
        {
          show: true,
          type: 'slider',
          start: 0,
          end: 100,
          bottom: '0%',
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '60%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }
      ],
      xAxis: {
        type: 'category',
        data: [],
        nameTextStyle: {
          color: '#fff'
        },
        axisLabel: {
          interval: 0,
          length: '100%',
          rotate: 30,
          color: '#fff'
        },
        splitArea: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        },
      },
      
      yAxis: {
        // name: '',
        // nameLocation: 'middle',
        // nameGap: 35,
        // nameRotate: 90,
        splitLine: {
          show: false
        },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        },
      },
      series: [
        {
          name: 'Total Cartons',
          type: 'line',
          data: [],
        },
        {
          name: 'Total Orders Allocated',
          type: 'line',
          data: [],
        },
        {
          name: 'Total Orders Dropped',
          type: 'line',
          data: [],
        },
        {
          name: 'Total Orders Partially Allocated',
          type: 'line',
          data: [],
        },
        {
          name: 'Total Orders Shorted',
          type: 'line',
          data: [],
        }
        ]
    };
  }

  init(widget: any) {
    console.log('Wave Performance')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Wave Performance';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.startWave = 0;
    widget.endWave = 10;
    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor('broadcastWavePerformance')
          .subscribe((result: any) => {
            console.log('broadcastWavePerformance', result);
            //need to format this 
            let resultwid;
            let resultcreationtime;
            let lastUpdatedTime;

            if (result.length > 0) {
              //console.log(result[0].IsNoDataFound);
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            }
            if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              let totalOrdersAllocated = [];
              let totalCartons = [];
              let totalOrdersShorted = [];
              let totalOrdersPartiallyAllocated = [];
              let totalOrdersDropped = [];
              let category = [];
              let hasData: boolean = false;

              for (let i = 0; i < result.length; i++) {
                if (widget.IfNoDataFound == false) {
                  hasData = true;
                  category.push(result[i].WaveNumber);
                  totalCartons.push([result[i].WaveNumber,
                  result[i].TotalCartons,
                  result[i].TotalOrdersAllocated,
                  result[i].TotalOrdersDropped,
                  result[i].TotalOrdersPartiallyAllocated,
                  result[i].TotalOrdersShorted,
                  result[i].WaveDescription,
                  result[i].WaveSelectedTime,
                  result[i].WaveAllocatedTime,
                  result[i].WaveCubeTime,
                  result[i].WaveTaskGeneratedTime
                  ]);
                  totalOrdersAllocated.push([result[i].WaveNumber,
                    result[i].TotalOrdersAllocated,
                  ]);
                  totalOrdersShorted.push([result[i].WaveNumber,
                  result[i].TotalOrdersShorted
                  ]);
                  totalOrdersPartiallyAllocated.push([result[i].WaveNumber,
                  result[i].TotalOrdersPartiallyAllocated
                  ]);
                  totalOrdersDropped.push([result[i].WaveNumber,
                  result[i].TotalOrdersDropped
                  ]);
                }
              }

              if (!hasData) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.chartOptions.series[0].data = totalCartons;
              widget.chartOptions.series[1].data = totalOrdersAllocated;
              widget.chartOptions.series[2].data = totalOrdersDropped;
              widget.chartOptions.series[3].data = totalOrdersPartiallyAllocated;
              widget.chartOptions.series[4].data = totalOrdersShorted;
              
              widget.chartOptions.xAxis.data = category;
              this._commonService.lastUpdatedTime = lastUpdatedTime;
            }
            //console.log(result)  ;
            widget.dataLoaded = true;
          }
            , err => {
              console.log('listenFor broadcastWavePerformance error', err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEPERFORMANCE";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "WAVEPERFORMANCE",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
            //do nothing
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEPERFORMANCE";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "WAVEPERFORMANCE",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) { }
          console.log('deleteWidget WAVEPERFORMANCE RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }



}



// WEBPACK FOOTER //
// ./src/app/services/widgets/waveperformance.service.ts